import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'trigger_update_app_permissions',
  handler: () => async () =>
    window.__webview_comms__.trigger('update-app-permissions')
});
